import React, { useEffect, useState, useRef } from "react";
import "./Verification_Puzzle_modal.css";
import { Modal } from "react-bootstrap";
import UPI_Withdrawal_Remainder from "../UPI_Withdrawal_Remainder/UPI_Withdrawal_Remainder";
import {
  faXmark,
  faRotateRight,
  faCircleExclamation,
  faRightLong,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Successfull_strip_modal from "../Successfull_strip_modal/Successfull_strip_modal";

function Verification_Puzzle_modal({ show, onVerified, onHide }) {
  const [showVerification, setShowVerification] = useState(false);
  const [showUPI, setShowUPI] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("Login Successfull");
  const navigate = useNavigate();
  // Puzzle Logic States
  const [pieceLeft, setPieceLeft] = useState(10);
  const [isDragging, setIsDragging] = useState(false);
  const [targetPos, setTargetPos] = useState(150);
  const [puzzleImg, setPuzzleImg] = useState("");
  const sliderRef = useRef(null);

  // Function to randomize image and hole position
  const handleRefresh = () => {
    setPieceLeft(10);
    const randomId = Math.floor(Math.random() * 500);
    // Using a 400x240 ratio for better quality in the modal
    setPuzzleImg(`https://picsum.photos/id/${randomId}/400/240`);
    // Randomize hole between 100px and 220px
    setTargetPos(Math.floor(Math.random() * 120) + 100);
  };

  useEffect(() => {
    if (show) {
      setShowVerification(true);
      setShowUPI(false);
      handleRefresh();
    }
  }, [show]);


  // useEffect(() => {
  //   if (modalShow) {
  //     const timer = setTimeout(() => {
  //       setModalShow(false);
  //       navigate("/home");
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [modalShow, navigate]);

  const handleMouseDown = () => setIsDragging(true);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging || !sliderRef.current) return;

      const rect = sliderRef.current.getBoundingClientRect();
      const clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;

      let offsetX = clientX - rect.left - 20;

      // Boundary checks
      const min = 5;
      const max = rect.width - 45;
      if (offsetX < min) offsetX = min;
      if (offsetX > max) offsetX = max;

      setPieceLeft(offsetX);
    };

    const handleMouseUp = () => {
      if (!isDragging) return;
      setIsDragging(false);

      // Verify: check if piece matches hole within 8px margin
      if (Math.abs(pieceLeft - targetPos) < 8) {
        // Success: visual feedback then switch modals
        setPieceLeft(targetPos);
        setModalShow(true);
        setTimeout(() => {
          setShowVerification(false);
          onVerified?.();
          const timer = setTimeout(() => {
            setModalShow(false);
            navigate("/home");
          }, 1000);

          return () => clearTimeout(timer);
        }, 600);
      } else {
        // Fail: snap back to start
        setPieceLeft(10);
      }
    };

    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      window.addEventListener("touchmove", handleMouseMove);
      window.addEventListener("touchend", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [isDragging, pieceLeft, targetPos]);

  return (
    <>
      <Modal
        show={showVerification}
        centered
        size="sm"
        backdrop="static"
        className="Verification_Puzzle_modal Common_modal"
      >
        <Modal.Header>
          <Modal.Title>Verification:</Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="close-icon"
            onClick={() => {
              setShowVerification(false);
              onHide();
            }}
          />
        </Modal.Header>

        <Modal.Body>
          <div className="verification-container">
            {/* Puzzle Area */}
            <div className="puzzle-image-wrapper">
              <img src={puzzleImg} className="puzzle-bg" alt="bg" />


              {/* Hole in the background */}
              <div
                className="puzzle-hole"
                style={{ left: `${targetPos}px` }}
              ></div>

              {/* Slidable Piece */}
              <div
                className="puzzle-piece"
                style={{
                  left: `${pieceLeft}px`,
                  backgroundImage: `url(${puzzleImg})`,
                  backgroundPosition: `-${targetPos}px -40px`, // Cuts from the hole location
                  backgroundSize: "280px 180px", // Matches the wrapper dimensions
                }}
              ></div>
            </div>

            {/* Slider Track */}
            <div className="slider-wrapper" ref={sliderRef}>
              <div
                className="slider-button"
                onMouseDown={handleMouseDown}
                onTouchStart={handleMouseDown}
                style={{ left: `${pieceLeft - 10}px` }}
              >
                <FontAwesomeIcon icon={faRightLong} />
              </div>
              <span
                className="slider-text"
                style={{ opacity: pieceLeft > 60 ? 0 : 1 }}
              >
                Drag the slider to fit the puzzle piece
              </span>
            </div>

            {/* Footer Buttons */}
            <div className="verification-footer">
              <span className="footer-btn" onClick={handleRefresh}>
                <FontAwesomeIcon icon={faRotateRight} /> Refresh
              </span>
              <span className="footer-btn">
                <FontAwesomeIcon icon={faCircleExclamation} /> Report a problem
              </span>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <UPI_Withdrawal_Remainder
        show={showUPI}
        onHide={() => {
          setShowUPI(false);
          onHide();
        }}
      /> */}

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Verification_Puzzle_modal;
